"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DROPDOWN_FILTER_DEFAULT_PROP = exports.DROPDOWN_FILTER_PROP_TYPE = exports.DROPDOWN_DIMENSIONS_DEFAULT_PROP = exports.DROPDOWN_DIMENSIONS_PROP_TYPE = exports.DIMENSIONS_DEFAULT_PROP = exports.DIMENSIONS_PROP_TYPE = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var DIMENSIONS_PROP_TYPE = _propTypes["default"].shape({
  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
});

exports.DIMENSIONS_PROP_TYPE = DIMENSIONS_PROP_TYPE;
var DIMENSIONS_DEFAULT_PROP = {
  maxWidth: null,
  minWidth: null,
  width: null
};
exports.DIMENSIONS_DEFAULT_PROP = DIMENSIONS_DEFAULT_PROP;

var DROPDOWN_DIMENSIONS_PROP_TYPE = _propTypes["default"].shape({
  menu: DIMENSIONS_PROP_TYPE,
  toggle: DIMENSIONS_PROP_TYPE
});

exports.DROPDOWN_DIMENSIONS_PROP_TYPE = DROPDOWN_DIMENSIONS_PROP_TYPE;
var DROPDOWN_DIMENSIONS_DEFAULT_PROP = {
  menu: DIMENSIONS_DEFAULT_PROP,
  toggle: DIMENSIONS_DEFAULT_PROP
};
exports.DROPDOWN_DIMENSIONS_DEFAULT_PROP = DROPDOWN_DIMENSIONS_DEFAULT_PROP;

var DROPDOWN_FILTER_PROP_TYPE = _propTypes["default"].shape({
  filterString: _propTypes["default"].string,
  isVisible: _propTypes["default"].bool,
  placeholder: _propTypes["default"].string,
  onFilterChange: _propTypes["default"].func
});

exports.DROPDOWN_FILTER_PROP_TYPE = DROPDOWN_FILTER_PROP_TYPE;
var DROPDOWN_FILTER_DEFAULT_PROP = {
  isVisible: false,
  filterString: '',
  placeholder: null,
  onFilterChange: function onFilterChange() {}
};
exports.DROPDOWN_FILTER_DEFAULT_PROP = DROPDOWN_FILTER_DEFAULT_PROP;